import React, { useCallback, useEffect } from "react";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { Typography } from "@material-ui/core";

import { BackButton, Header } from "halifax";
import { FlightShopStep, TripCategory } from "redmond";

import { flightShopProgressSelector } from "../../../shop/reducer";
import { getTripCategory } from "../../../search/reducer";
import { useNavigateToChfar } from "../../hooks/useNavigateToChfar";
import { setFlightShopProgress } from "../../../shop/actions/actions";

import styles from "./styles.module.scss";

export const ChfarMobileFlightShopHeader: React.FC = () => {
  const dispatch = useDispatch();
  const flightShopStep = useSelector(flightShopProgressSelector);
  const isRoundTrip = useSelector(getTripCategory) === TripCategory.ROUND_TRIP;

  const navigateToChfar = useNavigateToChfar();

  const handleGoBack = useCallback(() => {
    switch (flightShopStep) {
      case FlightShopStep.ChooseDeparture:
        navigateToChfar();
        break;

      case FlightShopStep.ChooseReturn:
        dispatch(setFlightShopProgress(FlightShopStep.ChooseDeparture));
        break;

      case FlightShopStep.ReviewItinerary:
        if (isRoundTrip) {
          dispatch(setFlightShopProgress(FlightShopStep.ChooseReturn));
        } else {
          dispatch(setFlightShopProgress(FlightShopStep.ChooseDeparture));
        }
        break;

      default: {
        navigateToChfar();
        break;
      }
    }
  }, [flightShopStep, isRoundTrip, navigateToChfar, setFlightShopProgress]);

  useEffect(() => {
    const banner = document.querySelector(".b2b-portal-banner-root");
    if (banner == null) {
      return () => {};
    }

    const observer = new ResizeObserver((entries) =>
      document.documentElement.style.setProperty(
        "--chfar-mobile-flight-shop-header-height",
        `${entries[0].contentRect.height}px`
      )
    );

    observer.observe(banner);

    return () => observer.disconnect();
  }, []);

  return (
    <Header
      data-id="chfar-mobile-flight-shop-header"
      left={<BackButton onClick={handleGoBack} />}
      className={clsx(
        styles["chfar-mobile-flight-shop-header"],
        "chfar-mobile-flight-shop-header"
      )}
      center={
        <Typography variant="body1">
          {flightShopStep === FlightShopStep.ReviewItinerary ||
          flightShopStep === FlightShopStep.FareDetails
            ? "Review Itinerary"
            : "Choose new flight"}
        </Typography>
      }
      isMobile
      fullWidth
    />
  );
};
